// src/util/replace-assignments/index.ts
function assign(fn, value) {
  if (fn) {
    fn(value);
    return value;
  }
  throw new TypeError("Assignment to constant variable.");
}
export {
  assign as default
};
